import { render, staticRenderFns } from "./goods-dialog.vue?vue&type=template&id=4893cf04&"
import script from "./goods-dialog.vue?vue&type=script&lang=js&"
export * from "./goods-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports